import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import WhatsApp from "../../assets/whatsapp.png";

import { useNavigate } from "react-router-dom";

import aboutHero from "../../assets/beach-hero.jpg";

import dhamma from "../../assets/place15.jpg";
import sigiriya from "../../assets/relax-at-arugam-bay.jpg";
import kandy from "../../assets/place22.jpg";
import temple from "../../assets/battala-1.jpg";

function CoastalAndBeachTour() {

    const navigate = useNavigate();

    const images = [dhamma, sigiriya, kandy, temple];

    const [selectedImage, setSelectedImage] = useState(images[0]);

    const [day1, setDay1] = useState(true);
    const [day2, setDay2] = useState(false);
    const [day3, setDay3] = useState(false);
    const [day4, setDay4] = useState(false);
    const [day5, setDay5] = useState(false);
    const [day6, setDay6] = useState(false);
    const [day7, setDay7] = useState(false);
    const [day8, setDay8] = useState(false);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Coastal & Beach Tour
                    </h1>
                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        Experience the beauty of Sri Lanka’s coastline with golden beaches and tropical ocean views.
                    </p>
                </div>
            </section>

            {/* ================= CULTURAL HIGHLIGHTS ================= */}
            <section className="bg-white -py-2">
                <div className="mx-auto max-w-7xl px-6 text-center">

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mx-auto mt-6 max-w-4xl text-gray-600 leading-relaxed"
                    >
                        Enjoy an unforgettable 8-day beach escape along the stunning coast of Sri Lanka.
                        Start in Negombo with relaxing beaches and sunset views, then head to Bentota for water sports and river cruises. Continue to Hikkaduwa for snorkeling and vibrant beach life, and visit Mirissa for whale watching and surfing.
                        End your journey in Unawatuna, perfect for swimming, relaxing, and enjoying the tropical coastal atmosphere.
                    </p>

                    {/* Duration Bar */}
                    <div
                        data-aos="fade-up"
                        data-aos-delay="250"
                        className="mx-auto mt-10 flex max-w-4xl items-center justify-center rounded-md bg-gradient-to-r from-[#0A3A5E] to-[#1C6EA4] py-5 text-white"
                    >
                        <div className="flex items-center gap-4">
                            <span className="text-3xl">📅</span>
                            <div className="text-left">
                                <p className="text-sm uppercase tracking-widest">Duration</p>
                                <p className="text-xl font-bold">8 Days / 7 Nights</p>
                            </div>
                        </div>
                    </div>

                    {/* Main Image */}
                    <div
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        className="mx-auto mt-10 overflow-hidden rounded-xl shadow-xl"
                    >
                        <img
                            src={selectedImage}
                            alt="Selected Tour"
                            className="w-full h-[250px] sm:h-[350px] md:h-[450px] lg:h-[600px] xl:h-[720px] object-cover transition duration-500"
                        />
                    </div>

                    {/* Thumbnail Gallery */}
                    <div
                        data-aos="fade-up"
                        data-aos-delay="400"
                        className="mx-auto mt-8 grid max-w-5xl grid-cols-2 gap-4 sm:grid-cols-4"
                    >
                        {images.map((img, index) => (
                            <img
                                key={index}
                                src={img}
                                onClick={() => setSelectedImage(img)}
                                className={`h-28 w-full cursor-pointer rounded-lg object-cover transition-all duration-300 
                                hover:scale-105
                                ${selectedImage === img ? "ring-4 ring-[#0A3A5E]" : "opacity-70"}
                            `}
                            />
                        ))}
                    </div>

                </div>
            </section>

            {/* ================= TOUR ITINERARY ================= */}
            <section className="bg-gray-50 py-10">
                <div className="mx-auto max-w-6xl px-6">

                    <h2
                        data-aos="fade-up"
                        className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Coastal & Beach Tour Itinerary
                    </h2>

                    <div className="mt-12 space-y-6">

                        {/* ================= DAY 1 ================= */}
                        <div className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay1(!day1)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 1: Airport → Negombo</span>
                                <span>{day1 ? "−" : "+"}</span>
                            </button>

                            {day1 && (
                                <div className="space-y-5 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Welcome to Sri Lanka! Upon arrival, you will be greeted and transferred to Negombo.</p>
                                    <p>Relax on the beach and enjoy the sunset after your journey.</p>
                                    <p className="font-semibold">Overnight stay in Negombo.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 2 ================= */}
                        <div className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay2(!day2)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 2: Negombo → Bentota</span>
                                <span>{day2 ? "−" : "+"}</span>
                            </button>

                            {day2 && (
                                <div className="space-y-5 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>After breakfast, travel down the coast to Bentota.</p>
                                    <p>Enjoy river safari at Madu River and visit a turtle hatchery.</p>
                                    <p>Relax on Bentota’s golden beaches.</p>
                                    <p className="font-semibold">Overnight stay in Bentota.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 3 ================= */}
                        <div className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay3(!day3)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 3: Bentota → Galle → Unawatuna</span>
                                <span>{day3 ? "−" : "+"}</span>
                            </button>

                            {day3 && (
                                <div className="space-y-5 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Proceed to Galle and explore the famous Dutch Fort (UNESCO site).</p>
                                    <p>Walk along cobbled streets, lighthouse, and views.</p>
                                    <p>Continue to Unawatuna for beach relaxation.</p>
                                    <p className="font-semibold">Overnight stay in Unawatuna.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 4 ================= */}
                        <div className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay4(!day4)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 4: Unawatuna → Mirissa</span>
                                <span>{day4 ? "−" : "+"}</span>
                            </button>

                            {day4 && (
                                <div className="space-y-5 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Travel to Mirissa, one of Sri Lanka’s most beautiful beaches.</p>
                                    <p>Optional whale watching tour (seasonal).</p>
                                    <p>Enjoy beach time, surfing, or relaxing by the sea.</p>
                                    <p className="font-semibold">Overnight stay in Mirissa.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 5 ================= */}
                        <div className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay5(!day5)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 5: Mirissa → Yala</span>
                                <span>{day5 ? "−" : "+"}</span>
                            </button>

                            {day5 && (
                                <div className="space-y-5 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Proceed to Yala National Park.</p>
                                    <p>Enjoy an exciting jeep safari to spot leopards, elephants, and wildlife.</p>
                                    <p className="font-semibold">Overnight stay near Yala.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 6 ================= */}
                        <div className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay6(!day6)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 6: Yala → Tangalle</span>
                                <span>{day6 ? "−" : "+"}</span>
                            </button>

                            {day6 && (
                                <div className="space-y-5 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Travel to Tangalle, known for its untouched beaches.</p>
                                    <p>Relax, swim, or enjoy a peaceful beach day.</p>
                                    <p className="font-semibold">Overnight stay in Tangalle.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 7 ================= */}
                        <div className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay7(!day7)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 7: Tangalle → Arugam Bay</span>
                                <span>{day7 ? "−" : "+"}</span>
                            </button>

                            {day7 && (
                                <div className="space-y-5 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>After breakfast, travel to Arugam Bay on the east coast.</p>
                                    <p>Relax on the beach and enjoy the laid-back surfing atmosphere.</p>
                                    <p>Sunset at Arugam Bay beach.</p>
                                    <p className="font-semibold">Overnight stay in Arugam Bay.</p>
                                </div>
                            )}
                        </div>

                        {/* ================= DAY 8 ================= */}
                        <div className="overflow-hidden rounded-lg border bg-white shadow">
                            <button onClick={() => setDay8(!day8)} className="flex w-full justify-between bg-gray-100 px-6 py-5 font-semibold text-[#0A3A5E]">
                                <span>Day 8: Arugam Bay → Colombo → Departure</span>
                                <span>{day8 ? "−" : "+"}</span>
                            </button>

                            {day8 && (
                                <div className="space-y-5 px-6 py-6 text-gray-700 leading-relaxed">
                                    <p>Early morning transfer from Arugam Bay to Colombo.</p>
                                    <p>Optional short city tour or shopping in Colombo.</p>
                                    <p>Proceed to Bandaranaike International Airport for departure.</p>
                                    <p className="font-semibold">End of Tour.</p>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= ROUTE MAP ================= */}
            <section className="bg-white -py-2">
                <div className="mx-auto max-w-7xl px-6">

                    <div
                        className="ch-left mx-auto max-w-5xl"
                        data-aos="fade-right"
                    >
                        <h1
                            data-aos="fade-up"
                            className="mb-6 text-center text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                        >
                            Route
                        </h1>

                        <div className="flex flex-col lg:flex-row gap-6">

                            {/* Map */}
                            <div className="map-container flex-1 overflow-hidden rounded-xl shadow-xl border">
                                <iframe
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    loading="lazy"
                                    allowFullScreen
                                    src="https://www.google.com/maps/embed/v1/directions?key=AIzaSyDZqfXy1xcje1qgbyaF-Kb_qoRtUJc_lik
                                    &origin=Colombo,Sri+Lanka
                                    &destination=Colombo,Sri+Lanka
                                    &waypoints=Negombo,Sri+Lanka|Bentota,Sri+Lanka|Galle,Sri+Lanka|Unawatuna,Sri+Lanka|Mirissa,Sri+Lanka|Yala,Sri+Lanka|Tangalle,Sri+Lanka|Arugam+Bay,Sri+Lanka
                                    &avoid=tolls|highways">
                                </iframe>
                            </div>

                            {/* Route Info */}
                            <div className="route-info w-full h-[100px] lg:w-[300px] flex flex-col items-start gap-3 rounded-lg bg-gray-100 p-5 text-lg shadow">
                                <p><strong>Distance:</strong> 635 km</p>
                                <p><strong>Duration:</strong> 19 hr</p>
                            </div>

                        </div>

                    </div>

                </div>
            </section>

            {/* ================= IMPORTANT INFO + CTA ================= */}
            <section className="bg-white py-10">
                <div className="mx-auto max-w-7xl px-6">

                    {/* Important Points */}
                    <div data-aos="fade-up" className="mx-auto max-w-4xl">
                        <h3 className="mb-6 text-center text-2xl font-bold text-[#0A3A5E]">
                            Important points to note
                        </h3>

                        <ul className="space-y-4 text-gray-700">
                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    After making the payment, any booking cannot be cancelled.
                                    Hence, once the payment is made it will not be refunded.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    Additional services and excursions that are optional may be provided,
                                    though for an additional charge.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    The official check-in time at all hotels is at 12:00 pm.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    The official check-out time at all hotels is at 11:00 am.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="mt-1 text-[#0A3A5E]">◆</span>
                                <p>
                                    Visits to wildlife parks will be at one’s own risk. Jeeps and vehicles
                                    available here are without air conditioning and come with basic insurance
                                    covers (not comprehensive as in the case of vehicles used for our tours).
                                </p>
                            </li>
                        </ul>
                    </div>

                    {/* CTA Box */}
                    <div
                        data-aos="zoom-in"
                        className="mt-10 w-full rounded-lg bg-gray-100 px-6 py-10 text-center shadow"
                    >
                        <h2 className="mb-6 text-xl sm:text-2xl font-semibold text-gray-800">
                            Experience your dream holiday in Sri Lanka!
                        </h2>

                        <button
                            onClick={() => navigate(`/book-now`)}
                            className="rounded-full bg-[#00A9C7] px-10 py-3 text-white font-semibold transition hover:bg-[#008eaa]">
                            BEGIN YOUR JOURNEY
                        </button>
                    </div>

                    {/* Related Destinations */}
                    <div data-aos="fade-up" className="mt-10 text-left">
                        <h3 className="mb-6 text-xl font-bold text-gray-700">
                            RELATED DESTINATIONS
                        </h3>

                        <div className="flex flex-wrap justify-start gap-3">
                            {[
                                "Colombo",
                                "Negombo",
                                "Bentota",
                                "Galle",
                                "Unawatuna",
                                "Mirissa",
                                "Yala",
                                "Tangalle",
                                "Arugam Bay"
                            ].map((place, i) => (
                                <span
                                    key={i}
                                    className="rounded-full bg-gray-200 px-5 py-2 text-sm font-medium text-gray-700 transition hover:bg-[#0A3A5E] hover:text-white cursor-pointer"
                                >
                                    {place}
                                </span>
                            ))}
                        </div>
                    </div>

                </div>
            </section>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94769245905"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src={require("../../assets/whatsapp.png")}
                    alt="WhatsApp Icon"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default CoastalAndBeachTour;
